import { computed, ref, Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useScheduleFilterStore } from '../stores/scheduleFilterStore'

export type ScheduleCopyDialogState = {
    visible: boolean
}

const state: Ref<ScheduleCopyDialogState> = ref({
    visible: false,
})

export function useScheduleCopyDialog() {
    const scheduleFilterStore = useScheduleFilterStore()
    const {
        dateFrom,
        dateTo,
        viewDuration,
        building,
    } = storeToRefs(scheduleFilterStore)

    const show = () => {
        state.value = {
            visible: true,
        }
    }

    const hide = () => {
        state.value = {
            visible: false,
        }
    }

    const isShown = computed(() => state.value.visible)

    return {
        show,
        hide,
        isShown,
        dateFrom,
        dateTo,
        building,
        viewDuration,
    }
}